import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CBScrollbarModule } from '@core/directives/scrollbar/public-api';
import { BxHorizontalNavigationBasicItemComponent } from '@core/components/navigation/horizontal/components/basic/basic.component';
import { BxHorizontalNavigationBranchItemComponent } from '@core/components/navigation/horizontal/components/branch/branch.component';
import { BxHorizontalNavigationDividerItemComponent } from '@core/components/navigation/horizontal/components/divider/divider.component';
import { BxHorizontalNavigationSpacerItemComponent } from '@core/components/navigation/horizontal/components/spacer/spacer.component';
import { BxHorizontalNavigationComponent } from '@core/components/navigation/horizontal/horizontal.component';
import { BxVerticalNavigationAsideItemComponent } from '@core/components/navigation/vertical/components/aside/aside.component';
import { BxVerticalNavigationBasicItemComponent } from '@core/components/navigation/vertical/components/basic/basic.component';
import { BxVerticalNavigationCollapsableItemComponent } from '@core/components/navigation/vertical/components/collapsable/collapsable.component';
import { BxVerticalNavigationDividerItemComponent } from '@core/components/navigation/vertical/components/divider/divider.component';
import { BxVerticalNavigationGroupItemComponent } from '@core/components/navigation/vertical/components/group/group.component';
import { BxVerticalNavigationSpacerItemComponent } from '@core/components/navigation/vertical/components/spacer/spacer.component';
import { BxVerticalNavigationComponent } from '@core/components/navigation/vertical/vertical.component';

@NgModule({
    declarations: [
        BxHorizontalNavigationBasicItemComponent,
        BxHorizontalNavigationBranchItemComponent,
        BxHorizontalNavigationDividerItemComponent,
        BxHorizontalNavigationSpacerItemComponent,
        BxHorizontalNavigationComponent,
        BxVerticalNavigationAsideItemComponent,
        BxVerticalNavigationBasicItemComponent,
        BxVerticalNavigationCollapsableItemComponent,
        BxVerticalNavigationDividerItemComponent,
        BxVerticalNavigationGroupItemComponent,
        BxVerticalNavigationSpacerItemComponent,
        BxVerticalNavigationComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        CBScrollbarModule
    ],
    exports     : [
        BxHorizontalNavigationComponent,
        BxVerticalNavigationComponent
    ]
})
export class BxNavigationModule
{
}
